import { Menu } from 'antd';
import type { FC, ReactNode } from 'react';
import { useCallback, useState } from 'react';

import type { Club } from 'app/typings/clubs';

import { ListPage } from './ListPage';

export const ClubListPage: FC<Props> = ({
  title,
  clubs,
  withContentWrapper,
  children,
}) => {
  const [clubId, setClubId] = useState(1);
  const [countryId, setCountryId] = useState(1);

  const handleChangeTab = useCallback(
    ({ key }: { key: string }) => {
      setClubId(+key);

      const club = clubs?.find((cl) => cl.id === +key);

      if (club) {
        setCountryId(club.countryId);
      }
    },
    [clubs]
  );

  return (
    <ListPage
      title={title}
      menu={
        <Menu
          mode="horizontal"
          onClick={handleChangeTab}
          selectedKeys={[clubId.toString()]}
          items={clubs?.map((cl) => ({
            key: cl.id.toString(),
            label: cl.name,
          }))}
        />
      }
      withContentWrapper={withContentWrapper}
    >
      {children({ clubId, countryId })}
    </ListPage>
  );
};

type ChildProps = {
  clubId: number;
  countryId: number;
};

type Props = {
  title: string;
  clubs: Club[] | undefined;
  withContentWrapper?: boolean;
  children: (props: ChildProps) => ReactNode;
};
